// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 18.9097L10.5003 19.5004L10.5 18.5448L14.5 14.5448V5.09051L9.5 2.1377V18.9097Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2.50012V11.4709L19.7869 9.25781L16.5 12.5448V4.76744L22 2.50012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.9143 16.2136L19.7867 12.0859L12.5 19.3726L12.5012 23.5002H16.6277L23.9143 16.2136ZM17.4507 17.2504L18.7499 18.5496L15.7993 21.5002H14.5006L14.5002 20.2008L17.4507 17.2504Z"}}]};

const MapEditFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-edit-filled',
    ref,
    icon: element,
  },
));

MapEditFilledIcon.displayName = 'MapEditFilledIcon';

export default MapEditFilledIcon;
